import api from './api';

export interface Empresa {
  id: number;
  nome: string;
  cnpj: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateEmpresaDTO {
  nome: string;
  cnpj: string;
}

export const empresaService = {
  listar: async (): Promise<Empresa[]> => {
    const response = await api.get('/empresas');
    return response.data;
  },

  criar: async (empresa: CreateEmpresaDTO): Promise<Empresa> => {
    const response = await api.post('/empresas', empresa);
    return response.data;
  },

  atualizar: async (id: number, empresa: CreateEmpresaDTO): Promise<Empresa> => {
    const response = await api.put(`/empresas/${id}`, empresa);
    return response.data;
  },

  excluir: async (id: number): Promise<void> => {
    await api.delete(`/empresas/${id}`);
  },
}; 